import { Button, Flex, Image, Space } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { useKeycloakStore, useUserDataStore } from '../../shared_stores';
import { observer } from 'mobx-react-lite';

export const Root = observer(
  ({ hideLoginButton = false }: { hideLoginButton?: boolean }) => {
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const kcStore = useKeycloakStore();
    const userDataStore = useUserDataStore();

    const handleProfileButton = () => {
      if (kcStore.authenticated) {
        void navigate('/profile');
      } else {
        //used instead of just calling kcStore.login to enable proper functionality with UnsavedChangesGuard
        void navigate(`/login?redirectUri=${window.location}`);
      }
    };

    return (
      <Flex
        direction={'column'}
        style={{
          backgroundColor: 'var(--mantine-color-seriousBlue-0)',
          height: '100vh',
        }}
      >
        <Flex
          style={{
            padding: 'var(--mantine-spacing-xs) var(--mantine-spacing-md)',
          }}
          direction={'row'}
          justify={'space-between'}
        >
          <Image
            style={{ margin: 'auto 0' }}
            h={35}
            src={'/../../../assets/img/combyn_logo.svg'}
            onClick={() => void navigate('/')}
          />
          <Space h={60} />
          {!hideLoginButton && (
            <Button
              variant={'white-text'}
              rightSection={
                <Image
                  style={{ width: 50, aspectRatio: 1 / 1, borderRadius: '50%' }}
                  src={
                    userDataStore.profilePicture
                      ? `data:image/*;base64,${userDataStore.profilePicture}`
                      : '/../../../assets/img/profile.svg'
                  }
                />
              }
              onClick={handleProfileButton}
            >
              {kcStore.authenticated ? kcStore.user?.email : t('login')}
            </Button>
          )}
        </Flex>
        <Outlet />
      </Flex>
    );
  },
);
